import layoutSaga from './layout/saga';
import { all } from 'redux-saga/effects';

export default function* rootSaga(): any {
    yield all([layoutSaga()]);
}
